export type VoiceGender = 'any' | 'female' | 'male';

const FEMALE_MARKERS = [
  'female',
  'zira',
  'hazel',
  'susan',
  'samantha',
  'victoria',
  'karen',
  'moira',
  'tessa',
  'fiona',
  'aria',
  'jenny',
  'ana',
  'sara',
  'jane',
  'emma'
];
const MALE_MARKERS = [
  'male',
  'david',
  'mark',
  'daniel',
  'alex',
  'fred',
  'jorge',
  'rishi',
  'guy',
  'tom'
];

export function inferGender(voice: SpeechSynthesisVoice): VoiceGender {
  const name = voice.name.toLowerCase();
  if (FEMALE_MARKERS.some((marker) => name.includes(marker))) return 'female';
  if (MALE_MARKERS.some((marker) => name.includes(marker))) return 'male';
  return 'any';
}

function scoreVoice(voice: SpeechSynthesisVoice, lang: string, gender: VoiceGender): number {
  let score = 0;
  const langBase = lang.split('-')[0];
  if (voice.lang === lang) score += 10;
  else if (voice.lang.startsWith(langBase)) score += 5;
  else return -1;

  if (gender !== 'any') {
    const voiceGender = inferGender(voice);
    if (voiceGender === gender) score += 4;
    else if (voiceGender === 'any') score += 1;
  }

  if (voice.localService) score += 2;
  if (voice.default) score += 1;
  return score;
}

export function pickVoice(lang: string, gender: VoiceGender): SpeechSynthesisVoice | null {
  const voices = window.speechSynthesis.getVoices();
  if (!voices.length) return null;
  let best: SpeechSynthesisVoice | null = null;
  let bestScore = -1;
  for (const voice of voices) {
    const score = scoreVoice(voice, lang, gender);
    if (score > bestScore) {
      bestScore = score;
      best = voice;
    }
  }
  return bestScore >= 0 ? best : null;
}
